export const cores = [
	{ id: 'AMARELO', name: 'Amarelo' },
	{ id: 'AZUL', name: 'Azul' },
	{ id: 'BEGE', name: 'Bege' },
	{ id: 'BRANCA', name: 'Branca' },
	{ id: 'CINZA', name: 'Cinza' },
	{ id: 'DOURADA', name: 'Dourada' },
	{ id: 'GRENA', name: 'Grena' },
	{ id: 'LARANJA', name: 'Laranja' },
	{ id: 'MARROM', name: 'Marrom' },
	{ id: 'PRATA', name: 'Prata' },
	{ id: 'PRETA', name: 'Preta' },
	{ id: 'ROSA', name: 'Rosa' },
	{ id: 'ROXA', name: 'Roxa' },
	{ id: 'VERDE', name: 'Verde' },
	{ id: 'VERMELHA', name: 'Vermelha' },
	{ id: 'FANTASIA', name: 'Fantasia' },
];

export const coresPorId = cores.reduce((coresPorId, cor) => {
	coresPorId[cor.id] = cor;
	return coresPorId;
});

export default cores;
